import { useId } from 'react';

export interface SelectOption<V extends string> {
  value: V;
  label: string;
}

interface SelectProps<V extends string> {
  label: string;
  value: V;
  options: SelectOption<V>[];
  onChange(value: V): void;
}

// A compact labelled dropdown for filter bars, where a full-width form Field would crowd the row.
export function Select<V extends string>({ label, value, options, onChange }: SelectProps<V>) {
  const id = useId();
  return (
    <div className="flex items-center gap-2 text-sm">
      <label htmlFor={id} className="text-slate-600">
        {label}
      </label>
      <select
        id={id}
        value={value}
        onChange={(event) => {
          const chosen = options.find((option) => option.value === event.target.value);
          if (chosen) onChange(chosen.value);
        }}
        className="select-arrow rounded-md border border-slate-300 bg-white py-1.5 pl-2 pr-8 text-sm focus:border-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-200"
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
}
